module.exports = __webpack_public_path__ + "img/first-comparison2.b0a9ce2c.gif";